import Vue from 'vue';

const mutations = {
  setShowHeadingsAndFilters(state, val) {
    state.flags.showHeadingsAndFilters = val;
  },
  setGoClicked(state, val) {
    state.flags.goClicked = val;
  },
  setLoadingSPData(state, val) {
    state.flags.loadingSPData = val;
  },
  setShowFootnotes(state, val) {
    state.flags.showFootnotes = val;
  },
  setGeneratingPdf(state, val) {
    state.flags.generatingPdf = val;
  },
  setGSGo(state, obj) {
    state.GSGo.locationId = obj.locationId;
    state.GSGo.location = obj.location;
    state.GSGo.categoryId = obj.categoryId;
    state.GSGo.category = obj.category;
    state.flags.goClicked = true;
  },
  setIndicatorId(state, val) {
    state.indicatorId = val;
  },
  setIndicators(state, arr) {
    state.indicators = arr;
  },
  setSPData(state, arr) {
    state.spData = arr;
  },
  setPanel(state, payload) {
    Vue.set(state.panels, payload.instance, payload.panelObj);
  },
  resetPanels(state) {
    state.panels = {};
  },
};

export default mutations;



// WEBPACK FOOTER //
// ./src/store/modules/SP/mutations.js